  <input  type="checkbox" (click)="checkedHandler($event)" [checked]="params.value == '1'" />
